<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-inventory-properties-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalInventoryProperties"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-inventory-properties-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modalInventoryProperties"
    ></button>
    <div id="custom-overlay" class="custom-modal-overlay"></div>
    <div
      class="modal fade"
      id="modalInventoryProperties"
      tabindex="-1"
      aria-labelledby="modalInventoryPropertiesLabel"
      aria-hidden="true"
      style="z-index: 1055"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Inventory</h5>
            <i
              style="cursor: pointer"
              class="material-icons btn-close-modal justify-content-end"
              data-bs-dismiss="modal"
              >clear</i
            >
          </div>
          <div class="modal-body mb-3">
            <div style="max-width: 90%; margin: 0 auto">
              <h3 class="title-page fs-16 mb-0">
                General Inventory Properties
              </h3>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <div class="col-5 d-flex justify-content-end">
                    <label class="fw-bold mb-0">Base UOM</label>
                    <!-- <div class="note-icon ms-1" data-v-bc0ad158="" title="Unit of Measurements during stock-in, purchase">!</div> -->
                  </div>
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.base_uom"
                      type="text"
                      id="base_uom"
                      name="base_uom"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-12 row align-items-center">
                  <div class="col-5 d-flex justify-content-end">
                    <label class="fw-bold mb-0">Selling UOM</label>
                    <!-- <div class="note-icon ms-1" data-v-bc0ad158="" title="Unit of Measurements during sales">!</div> -->
                  </div>
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.selling_uom"
                      type="text"
                      id="selling_uom"
                      name="selling_uom"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Conversion Rate <br />
                    (Base/Selling)</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.coversion_rate"
                      type="number"
                      id="coversion_rate"
                      name="coversion_rate"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Price excl. Tax</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.price_excl_tax"
                      type="number"
                      id="price_excl_tax"
                      name="price_excl_tax"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Cost per Unit</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.cost_per_unit"
                      type="number"
                      id="cost_per_unit"
                      name="cost_per_unit"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0">Profit %</label>
                  <div class="col-7">
                    <material-input
                      v-model="calculationProfit"
                      type="number"
                      id="profit"
                      name="profit"
                      :disabled="true"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <div class="col-5 d-flex justify-content-end">
                    <label class="fw-bold mb-0">Stock Type</label>
                    <!-- <div class="note-icon ms-1" data-v-bc0ad158="" title="how to track">!</div> -->
                  </div>
                  <div class="col-7">
                    <Multiselect
                      v-model="inventoryProperties.stock_type"
                      :options="stockTypes"
                      :canClear="false"
                      placeholder="Stock Type"
                    />
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-4 text-center">
                  <label class="text-center fw-bold">Low Stock QTY</label>
                  <material-input
                    v-model="inventoryProperties.low_stock_qty"
                    type="number"
                    id="low_stock_qty"
                    name="low_stock_qty"
                  />
                </div>
                <div class="col-4 text-center">
                  <label class="text-center fw-bold">High Stock QTY</label>
                  <material-input
                    v-model="inventoryProperties.high_stock_qty"
                    type="number"
                    id="high_stock_qty"
                    name="high_stock_qty"
                  />
                </div>
                <div class="col-4 text-center">
                  <label class="text-center fw-bold">Re-order QTY</label>
                  <material-input
                    v-model="inventoryProperties.reorder_qty"
                    type="number"
                    id="reorder_qty"
                    name="reorder_qty"
                  />
                </div>
              </div>
              <hr />
              <h3 class="title-page fs-16 mb-0">For Accounting/ERP Software</h3>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Cost of Sales Expense</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.cost_of_sales_expense"
                      type="text"
                      id="cost_of_sales_expense"
                      name="cost_of_sales_expense"
                    />
                  </div>
                </div>
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Sales Account</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.sales_account"
                      type="text"
                      id="sales_account"
                      name="sales_account"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-12 row align-items-center">
                  <label class="col-5 text-end fw-bold mb-0"
                    >Inventory Asset Account</label
                  >
                  <div class="col-7">
                    <material-input
                      v-model="inventoryProperties.inventory_asset_account"
                      type="text"
                      id="inventory_asset_account"
                      name="inventory_asset_account"
                    />
                  </div>
                </div>
              </div>
              <div class="note">
                <div
                  class="note-icon"
                  style="width: 20px; height: 20px; margin-top: 0"
                >
                  !
                </div>
                <div>
                  Note: a tracked inventory item must have 3 accounts selected.
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex mt-3">
              <material-button
                class="mx-2 btn btn-sm btn-background"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Cancel
              </material-button>
              <material-button
                style="
                  background-color: #1871bd !important;
                  color: white !important;
                  border-color: #1871bd !important;
                "
                class="mx-2 btn btn-sm btn-background"
                @click="updateInventoryProperties()"
              >
                Save
              </material-button>
            </div>
          </div>
          <material-loading :active="loaderActive" />
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-9999 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import { STATUS_IN_TRANSIT, STATUS_VOID } from "../mock_data";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import InventoryService from "../../../services/inventory.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import $ from "jquery";

export default {
  name: "ModalInventoryProperties",
  components: {
    MaterialButton,
    MaterialLoading,
    MaterialInput,
    MaterialSnackbar,
    Multiselect,
  },
  props: {
    keyReload: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    itemSelect: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      loaderActive: false,
      inventoryProperties: {
        base_uom: "Unit",
        selling_uom: "Unit",
        coversion_rate: 1,
        price_excl_tax: 0,
        cost_per_unit: 0,
        profit: 0,
        stock_type: "",
        low_stock_qty: 0,
        high_stock_qty: 0,
        reorder_qty: 0,
        cost_of_sales_expense: 0,
        sales_account: 0,
        inventory_asset_account: 0,
      },
      STATUS_IN_TRANSIT,
      STATUS_VOID,
      stockTypes: [
        {
          value: 1,
          label: "Standard",
        },
        {
          value: 2,
          label: "TNI",
        },
        {
          value: 3,
          label: "UNT",
        },
      ],
    };
  },
  computed: {
    calculationProfit() {
      if (!this.itemSelect?.others_price?.length) {
        return 0;
      }

      const firstPrice = this.itemSelect.others_price[0].price;

      if (firstPrice === 0) {
        return 0;
      }

      const profit =
        (this.inventoryProperties.price_excl_tax -
          this.inventoryProperties.cost_per_unit) /
        firstPrice;
      return parseFloat(profit).toFixed(2);
    },
  },
  methods: {
    getInventoryProperties() {
      this.showLoader();

      InventoryService.getInventoryProperties(this.itemId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;

            if (data.inventory_properties) {
              this.inventoryProperties = data.inventory_properties;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    updateInventoryProperties() {
      this.showLoader();
      this.inventoryProperties.profit = this.calculationProfit;

      InventoryService.updateInventoryProperties(this.inventoryProperties).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Update inventory properties successful";
            this.setTimeOutNotification();
            $(".btn-hide-inventory-properties-modal").click();
            this.$emit("reload-list");
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    closeSnackbar() {
      this.snackbar = null;
    },
  },
  watch: {
    keyReload: {
      handler() {
        this.inventoryProperties = {
          base_uom: "Unit",
          selling_uom: "Unit",
          coversion_rate: 1,
          price_excl_tax: 0,
          cost_per_unit: 0,
          profit: 0,
          stock_type: "",
          low_stock_qty: 0,
          high_stock_qty: 0,
          reorder_qty: 0,
          cost_of_sales_expense: 0,
          sales_account: 0,
          inventory_asset_account: 0,
        };

        if (this.itemSelect && this.itemSelect.inventory_properties) {
          this.inventoryProperties = this.itemSelect.inventory_properties;
        } else {
          this.getInventoryProperties();
        }
      },
    },
  },
};
</script>

<style scoped>
.modal-body {
  min-height: 50vh;
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}

.modal-body .row {
  margin-top: 10px;
}

.modal-dialog {
  max-width: 950px;
}

label,
.form-label {
  margin-left: 0px !important;
  color: black;
}

:deep(.input-group.input-group-dynamic .form-control) {
  background-image: none;
  border: 1px solid #d9d9d9 !important;
  padding: 4px 8px !important;
  margin-bottom: 0;
}

.note {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 10px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.note-icon {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  background: #f39c12;
  border-radius: 50%;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 12px;
}
</style>
